import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useGetDisplayOptionsClasses } from '@/composables/useGetDisplayOptionsClasses';
import useProductContent from '~/composables/useProductContent/useProductContent';
import ItemImageTextStandard from '~/components/cms/custom/ItemImageText/ItemImageTextStandard.vue';
import ItemImageTextTwo from '~/components/cms/custom/ItemImageText/ItemImageTextTwo.vue';
import { useParseDocumentToHtml } from '~/composables/useParseDocumentToHtml';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
export default defineComponent({
  name: 'BlockCardList',
  components: {
    NativeCarousel: NativeCarousel,
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    },
    ItemImageTextStandard: ItemImageTextStandard,
    ItemImageTextTwo: ItemImageTextTwo
  },
  props: {
    title: String,
    cards: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    catchphrase: {
      type: Object,
      default: function _default() {}
    },
    tabTitle: String,
    isContentExpanded: {
      type: Boolean,
      default: false
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isHomePage: Boolean,
    isInExpandableTab: Boolean,
    isInTabContainer: Boolean
  },
  setup: function setup(props) {
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var cardsComponents = computed(function () {
      return mapComponentName(props.cards).filter(function (e) {
        var _e$fields, _e$fields2, _e$fields3;
        // Apply filter only for ItemImageText component type
        if ((e === null || e === void 0 ? void 0 : (_e$fields = e.fields) === null || _e$fields === void 0 ? void 0 : _e$fields.component) != 'ItemImageText') return true;
        // ItemImageText need to have title or text to be displayed (just image is not enough)
        return ((_e$fields2 = e.fields) === null || _e$fields2 === void 0 ? void 0 : _e$fields2.title) || ((_e$fields3 = e.fields) === null || _e$fields3 === void 0 ? void 0 : _e$fields3.text);
      });
    });
    var componentName = computed(function () {
      return cardsComponents.value.some(function (card) {
        return card.fields.component == 'ItemImageText' || card.fields.component == 'LabeledLink';
      }) ? 'ItemImageTextStandard' : 'ItemImageTextTwo';
    });
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var _useParseDocumentToHt = useParseDocumentToHtml(props.catchphrase),
      parsedCatchphrase = _useParseDocumentToHt.html;
    var carouselKey = computed(function () {
      return props.isContentExpanded + props.title;
    });
    var sliderPerViews = computed(function () {
      if (props.isHomePage) {
        return 'auto';
      } else {
        return isMobile.value ? '1.2' : cardsComponents.value.length > 3 ? '2' : 'auto';
      }
    });
    var cauroselProps = useGlobalCauroselProps(cardsComponents, {
      desktop: 2,
      showOnlyOnHover: true
    });
    var isTitleNotEmpty = computed(function () {
      if (!props.title) return false;
      return !!props.title.trim().length;
    });
    return {
      cauroselProps: cauroselProps,
      isMobile: isMobile,
      carouselKey: carouselKey,
      classes: classes,
      cardsComponents: cardsComponents,
      componentName: componentName,
      parsedCatchphrase: parsedCatchphrase,
      sliderPerViews: sliderPerViews,
      isTitleNotEmpty: isTitleNotEmpty
    };
  }
});